import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import { SchoolProvider } from './contexts/SchoolContext';
import ErrorBoundary from './components/ErrorBoundary';

// After a new deploy, cached index.html may reference old chunk hashes that
// no longer exist. Vite fires this event when a dynamic import fails — reload
// once to pick up the new index.html. sessionStorage prevents an infinite loop
// if the reload itself somehow fails.
window.addEventListener('vite:preloadError', () => {
  const key = 'vite_chunk_reload';
  if (!sessionStorage.getItem(key)) {
    sessionStorage.setItem(key, '1');
    window.location.reload();
  }
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <AuthProvider>
          <SchoolProvider>
            <App />
          </SchoolProvider>
        </AuthProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>,
);
